import { jsxs, jsx } from "react/jsx-runtime";
const IconUserPlusSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M14 7h-.667v-.667a.666.666 0 1 0-1.333 0V7h-.667a.667.667 0 1 0 0 1.334H12V9a.667.667 0 1 0 1.333 0v-.666H14A.667.667 0 1 0 14 7ZM8.866 8.147A3.28 3.28 0 0 0 10 5.667a3.333 3.333 0 1 0-6.667 0 3.28 3.28 0 0 0 1.133 2.48A5.333 5.333 0 0 0 1.333 13a.667.667 0 0 0 1.333 0 4 4 0 0 1 8 0A.667.667 0 0 0 12 13a5.333 5.333 0 0 0-3.134-4.853Zm-2.2-.48a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z" })
    ]
  }
);
export {
  IconUserPlusSvg
};
